<template>
  <div style="background: #fff;">
    <div style="padding-top: 20px;">
        <ItemList ref="ItemList"></ItemList>
    </div>
  </div>
</template>
  
<script>
import ItemList from '@/components/ItemList.vue'
import {homeListPage} from '@/api/index'
export default {
  components: { ItemList },
  data(){
    return{
      pageNum:1,
    }
  },
  created(){
    this.homeListPage()
  },  
  methods:{
    //数据列表
    homeListPage(pageNum){
      homeListPage({
          pageSize:10,
          pageNum:pageNum||this.pageNum,
          biddingType:'',
          projectType:1,
          searchValue:'',
          sectionStautsList:'1,7,8'
      }).then(res=>{
          this.$refs.ItemList.tableData=res.rows
          this.$refs.ItemList.total=res.total
          this.$refs.ItemList.Loading=res.total?false:true


      })
    },  
  }
};
</script>
 